import { getPlayerRoleByIdSelector } from "@/redux/players/playersSlice";
import { clsx } from "clsx";
import { useSelector } from "react-redux";

type Props = {
  playerRoleId: number;
  focus: string;
  position: string;
  columns?: number;
};

export const PlayerRolePositionFocus = ({
  playerRoleId,
  focus,
  position,
  columns,
}: Props) => {
  const playerRole = useSelector(getPlayerRoleByIdSelector({ playerRoleId }));
  return (
    <div
      className={clsx(
        "flex flex-col justify-center items-center px-0.5 py-0.5 text-xxs rounded text-center bg-panel-foreground",
        columns < 4 ? "w-[76px]" : "w-full",
      )}
    >
      <p
        className={clsx(
          "text-white whitespace-nowrap truncate",
          columns < 4
            ? "w-[62px]"
            : columns === 4
              ? "w-[52px]"
              : " w-[40px] sb-v2-lg:w-[46px]",
        )}
      >
        {playerRole?.shortName}
      </p>
      <p className="text-gray-300">{focus}</p>
      <p className="text-secondary-dark">{position}</p>
    </div>
  );
};
